// extracted by mini-css-extract-plugin
export default {"button":"finecoButton_button__o6RXp","whiteVariant":"finecoButton_whiteVariant__5VCU3","notAllowed":"finecoButton_notAllowed__Q+ymN","allowed":"finecoButton_allowed__KsAw7"};